// Content filter utility
// The word list is intentionally empty — moderation focuses on blocking
// links, embedded media, and files rather than specific words.

const PROFANITY_LIST = [];

// Blocks anything that could be a link, an embedded picture/video, or a file:
// URLs, any scheme://, www., data: URIs, and common domain/media/file endings.
export const containsLink = (text) => {
  if (!text) return false;

  const patterns = [
    /https?:\/\//i,                 // http:// or https://
    /[a-z][a-z0-9+.-]*:\/\//i,      // any scheme:// (ftp, magnet, etc.)
    /\bwww\./i,                     // www.
    /data:/i,                       // data: URIs (embedded images/files)
    /blob:/i,                       // blob: URLs
    // bare domains, including media/file-sharing TLDs
    /\b[a-z0-9-]+\.(com|net|org|edu|gov|io|co|uk|ca|de|fr|au|jp|cn|ru|br|in|info|biz|tv|me|app|dev|tech|online|site|xyz|club|store|blog|gg|to|ly|link|media|stream|download|cloud|drive|file|files|img|video|photos|pics|gallery|sh|us|eu|news)\b/i,
    // common file extensions someone might paste
    /\.(png|jpe?g|gif|webp|bmp|svg|mp4|mov|webm|avi|mkv|mp3|wav|pdf|docx?|xlsx?|pptx?|zip|rar|7z|exe|apk|dmg)\b/i,
  ];

  return patterns.some((p) => p.test(text));
};

export const containsProfanity = (text) => {
  if (!text) return false;

  const lowerText = text.toLowerCase();
  for (const word of PROFANITY_LIST) {
    if (lowerText.includes(word)) {
      return true;
    }
  }
  return false;
};

export const getProfanityList = () => {
  return [...PROFANITY_LIST];
};
